<template>
  <div>
    <drop-down :multiLevel="true">
      <md-button class="md-button md-info dropdown-toggle md-wd">
            <span v-if="selectedGroup.isLeaf" style="height: 20px;">
              <img
                src="/img/green-dot.png"
                class="status-icon"
                alt="online"
                v-if="getStatus(selectedGroup.mac)"
              />
              <img src="/img/red-dot.png" class="status-icon" alt="offline" v-else />
            </span>
        <i v-if="selectedGroup.isLeaf" :class="getDeviceIcon(selectedGroup.type)"></i>
        <i v-else class="fa fa-home"></i>
        <span :title="selectedGroup.title">{{titleLength(selectedGroup.title)}}</span>
      </md-button>

      <div class="dropdown-menu">
        <sl-vue-tree
          v-model="nodes"
          ref="slVueTree"
          :allowMultiselect="false"
          @select="nodeSelected"
          @drop="nodeDropped"
          @nodedblclick="nodeDblClick"
          @toggle="nodeToggled"
        >
          <template slot="title" slot-scope="{ node }">
            <span v-if="node.isLeaf">
              <img
                src="/img/green-dot.png"
                class="status-icon"
                alt="online"
                v-if="getStatus(node.data.mac)"
              />
              <img src="/img/red-dot.png" class="status-icon" alt="offline" v-else />
            </span>

            <span class="item-icon">
              <i v-if="node.isLeaf" :class="getDeviceIcon(node.data.type)"></i>
              <i v-else class="fa fa-home"></i>
            </span>

            <span v-if="node.data.isEdited">
              <md-field style="display: inline;">
                <md-input
                  style="display: inline; width:100px;"
                  :value="node.title"
                  v-focus
                  v-on:keyup.enter="submitEditedElement(node, $event.target.value)"
                ></md-input>
              </md-field>
            </span>

            <span
              v-if="!node.data.isEdited"
              @mouseenter="nodeMouseEnter(node, $event)"
              @mouseleave="nodeMouseLeave(node, $event)"
            >
              <span :title="node.title">{{titleLength(node.title)}}</span>

              <span v-if="!node.isLeaf"> {{countOfChildren(node)}}</span>

              <md-button
                v-if="!node.isLeaf && node.data.showButton"
                class="md-button md-just-icon md-simple"
                @click="removeNode()"
              >
                <md-icon class="md-size-1x">close</md-icon>
              </md-button>

              <md-button
                v-if="node.isLeaf && node.data.showButton"
                class="md-button md-just-icon md-simple"
                @click="openModal(node, $event)"
              >
                <md-icon class="md-size-1x">more_vert</md-icon>
              </md-button>
            </span>
          </template>

          <template slot="toggle" slot-scope="{ node }">
            <span v-if="!node.isLeaf">
              <i v-if="node.isExpanded" class="fa fa-chevron-down"></i>
              <i v-if="!node.isExpanded" class="fa fa-chevron-right"></i>
            </span>
          </template>

          <template slot="sidebar" slot-scope="{ node }">
            <div style="display: inline-flex;">
              <md-chips
                v-model="menuTags[getTagIndex(node.data.id)].tags"
                class="md-primary"
                :md-limit="1"
                :md-placeholder="$lang.inputs.add_tag"
                @input="tagAdded"
                :md-static="node.isLeaf ? true : false"
              ></md-chips>

              <md-button
                v-if="node.isLeaf && !disableDevice(node.data.type)"
                class="md-primary md-just-icon md-simple"
                @click="toggleVisibility(node, $event)"
              >
                <md-icon v-show="node.data.report_visible">visibility</md-icon>
                <md-icon v-show="!node.data.report_visible" style="opacity: 0.55;">visibility_off</md-icon>
              </md-button>
            </div>
          </template>

          <template slot="draginfo">{{selectedGroup.dragTitle}}</template>
        </sl-vue-tree>

        <div class="hierarchy-new-object">
          <md-field>
            <label>{{$lang.keys.add_new_object}}</label>
            <md-input v-on:keyup.enter="submitNewElement()" v-model="newElement"></md-input>
          </md-field>
        </div>
      </div>
    </drop-down>

    <modal v-if="showModal" @close="modalClose">
      <template slot="header">
        <h4 class="modal-title">{{modalData.title}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modalClose">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <md-table>
          <md-table-row>
            <md-table-cell>MAC</md-table-cell>
            <md-table-cell>{{modalData.mac}}</md-table-cell>
          </md-table-row>
        </md-table>

        <router-link v-if="modalData.status === 'ONLINE'" to="/tools/device/settings">
          <md-button
            class="md-info md-block"
            :disabled="modalData.status !== 'ONLINE'"
          >{{$lang.menu.settings}}</md-button>
        </router-link>

        <md-button v-else class="md-info md-block" disabled>{{$lang.menu.settings}} (offline)</md-button>

        <h4 class="card-title">{{$lang.titles.location}}</h4>
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field>
              <label>{{$lang.keys.latitude}}</label>
              <md-input v-model="modalData.lat" type="text"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item">
            <md-field>
              <label>{{$lang.keys.longitude}}</label>
              <md-input v-model="modalData.lng" type="text"></md-input>
            </md-field>
          </div>
        </div>
      </template>

      <template slot="footer">
        <md-button class="md-primary" @click="saveModalData(modalData.mac)">{{$lang.keys.save}}</md-button>
        <md-button class="md-danger" @click="deleteModalDevice(modalData.mac)">{{$lang.keys.delete}}</md-button>
        <md-button class="md-simple" @click="modalClose">{{$lang.keys.close}}</md-button>
      </template>
    </modal>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import snackBar from "@/components/SnackBar";

import { getUserToken, getSelectedDeviceToken } from "@/storage/memoryStorage";
import SlVueTree from "sl-vue-tree";
import { Modal } from "@/components";
import axios from "axios";
import Swal from "sweetalert2";

const focus = {
  inserted(el) {
    el.focus();
  }
};

export default {
  name: "hierarchy-menu",
  directives: { focus },
  components: {
    snackBar,
    "sl-vue-tree": SlVueTree,
    Modal
  },
  data() {
    return {
      modalData: {},
      showModal: false,
      modalLoaded: false,

      newElement: "",
      nodes: [],
      menuTags: [],

      selectedGroup: {
        title: this.$lang.keys.no_group
      }
    };
  },
  computed: {
    deviceList() {
      return this.$store.getters.getDeviceList;
    }
  },

  created() {
    this.loadHierarchyContent();
  },

  methods: {
    getDeviceLabel(deviceTypeID) {
      switch (deviceTypeID) {
        case 1:
          return "MeriTo";
        case 2:
          return "Disconnector";
        case 3:
          return "PTE2300E";
        case 4:
          return "Octopus";
        case 5:
          return "OutageDetector";
        case 12:
          return "EYMON";
        default:
          return "MeriTo";
      }
    },

    getDeviceIcon(deviceTypeID) {
      switch (deviceTypeID) {
        case 1:
          return "fa fa-charging-station";
        case 2:
          return "fa fa-toggle-on";
        case 3:
          return "fas fa-suitcase";
        case 4:
          return "fas fa-atom";
        case 5:
          return "fas fa-plug";
        default:
          return "fa fa-charging-station";
      }
    },

    titleLength(title) {
      if (title.length > 20) {
        return title.slice(0, 20) + "...";
      }
      return title;
    },

    disableDevice(deviceID) {
      if (deviceID != 2) {
        return true;
      }

      return false;
    },

    propertyInitialization(devices) {
      if (devices.children) {
        for (let idx = 0; idx < devices.children.length; idx++) {
          if (devices.children[idx].isLeaf) {
            if (!this.disableDevice(devices.children[idx].data.type)) {
              if (
                !devices.children[idx].data.hasOwnProperty("report_visible")
              ) {
                devices.children[idx].data.report_visible = true;
              }
            }
          } else {
            this.propertyInitialization(devices.children[idx]);
          }
        }
      } else {
        for (let idx = 0; idx < devices.length; idx++) {
          if (devices[idx].isLeaf) {
            if (!this.disableDevice(devices[idx].data.type)) {
              if (!devices[idx].data.hasOwnProperty("report_visible")) {
                devices[idx].data.report_visible = true;
              }
            }
          } else {
            this.propertyInitialization(devices[idx]);
          }
        }
      }
    },

    getTagIndex(id) {
      let ret = null;
      ret = this.menuTags.findIndex(tag => tag.id == id);
      return ret;
    },

    saveModalData: function(mac) {
      const indexInMenu = this.getTagIndexByMAC(mac);

      this.menuTags[indexInMenu].lat = this.modalData.lat;
      this.menuTags[indexInMenu].lng = this.modalData.lng;

      this.updateHierarchyAPI();
      this.modalClose();
    },

    openModal: function(node, event) {
      this.modalLoaded = false;

      this.modalData.mac = node.data.mac;
      this.modalData.title =
        this.getDeviceLabel(node.data.type) + " " + node.title;
      this.modalData.status = this.deviceList[
        this.getIndexStatusList(node.data.mac)
      ].status;

      const indexInMenu = this.getTagIndex(node.data.id);
      this.modalData.lat = this.menuTags[indexInMenu].lat;
      this.modalData.lng = this.menuTags[indexInMenu].lng;

      this.showModal = true;
    },

    modalClose: function() {
      this.showModal = false;
    },

    getStatus: function(mac) {
      try {
        if (this.deviceList[this.getIndexStatusList(mac)].status == "ONLINE") {
          return 1;
        } else {
          return 0;
        }
      } catch (err) {
        return 0;
      }
    },

    getIndexStatusList(mac) {
      return this.deviceList.findIndex(e => e.mac == mac);
    },

    countOfChildren: function(node) {
      let counter = 0;

      node.children.forEach(element => {
        if (element.isLeaf) {
          counter++;
        }
      });

      if (counter > 0) {
        return "(" + counter + ")";
      } else {
        return "";
      }
    },

    updateHierarchyAPI() {
      const apiData = {
        nodes: this.nodes,
        tags: this.menuTags
      };

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/facility/devices-hierarchy",
        data: {
          token: getUserToken(),
          menu: apiData
        },
        withCredentials: true
      })
        .then(response => {})
        .catch(error => {
          this.$refs.snackbar.notify(
            this.$lang.messages.api_communication_error
          );
        });
    },

    getLastID() {
      let lastID = 1;

      try {
        this.menuTags.forEach(element => {
          try {
            if (element.id > lastID) {
              lastID = element.id;
            }
          } catch (err) {
            this.$refs.snackbar.notify(this.$lang.messages.general_error);
          }
        });
        return lastID;
      } catch {
        return lastID;
      }
    },

    selectDefaultGroup() {
      const nodesLength = this.nodes.length;
      if (nodesLength == 0) {
        this.selectedGroup.title = this.$lang.general.no_device;
        this.$emit("on-selected", []);
      } else {
        for (let i = 0; i < nodesLength; i++) {
          if (
            !this.nodes[i].isLeaf ||
            (this.nodes[i].isLeaf &&
              !this.disableDevice(this.nodes[i].data.type))
          ) {
            this.selectedGroup = {
              title: this.nodes[i].title,
              isLeaf: this.nodes[i].isLeaf,
              type: this.nodes[i].type,
              mac: this.nodes[i].data.mac,
            };

            this.$emit("on-selected", this.formatOutput(this.nodes[i]));
            return;
          }
        }
      }
    },

    loadHierarchyContent() {
      let saveHierarchyMenu = false;

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/facility/devices-hierarchy",
        data: {
          token: getUserToken()
        },
        withCredentials: true
      })
        .then(response => {
          this.nodes = response.data.data.nodes;
          this.menuTags = response.data.data.tags;

          this.deviceList.forEach(device => {
            if (this.getTagIndexByMAC(device.mac) == -1) {
              const deviceID = this.getLastID() + 1;

              let deviceTag = {
                id: deviceID,
                title: device.mac,
                mac: device.mac,
                tags: [this.getDeviceLabel(device.type)]
              };

              const deviceNode = {
                title: device.mac,
                isLeaf: true,
                data: {
                  id: deviceID,
                  mac: device.mac,
                  type: device.type,
                  report_visible: true
                }
              };

              this.menuTags.push(deviceTag);
              this.nodes.push(deviceNode);

              saveHierarchyMenu = true;
            }
          });
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code === 610) {
              this.deviceList.forEach(device => {
                const deviceID = this.getLastID() + 1;

                let deviceTag = {
                  id: deviceID,
                  title: device.mac,
                  mac: device.mac,
                  tags: [this.getDeviceLabel(device.type)]
                };

                const deviceNode = {
                  title: device.mac,
                  isLeaf: true,
                  data: {
                    id: deviceID,
                    mac: device.mac,
                    type: device.type,
                    report_visible: true
                  }
                };

                this.menuTags.push(deviceTag);
                this.nodes.push(deviceNode);

                saveHierarchyMenu = true;
              });
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        })
        .then(() => {
          this.$nextTick(() => {
            this.propertyInitialization(this.nodes);
          });
          this.selectDefaultGroup();
          if (saveHierarchyMenu) {
            this.updateHierarchyAPI();
          }
        });
    },

    addNewObject(name) {
      const ID = this.getLastID() + 1;
      const tag = { id: ID, tags: [] };
      const node = {
        title: name,
        isExpanded: false,
        children: [],
        data: {
          id: ID
        }
      };

      this.nodes.push(node);
      this.menuTags.push(tag);
      this.updateHierarchyAPI();
    },

    submitNewElement() {
      this.addNewObject(this.newElement);
      this.newElement = "";
    },

    getTagIndexByMAC(deviceMAC) {
      try {
        return this.menuTags.findIndex(tag => tag.mac == deviceMAC);
      } catch {
        return -1;
      }
    },

    submitEditedElement(nodeSelected, newNodeTitle) {
      const slVueTree = this.$refs.slVueTree;
      event.stopPropagation();

      if (!nodeSelected.isLeaf) {
        if (this.selectedGroup.title === nodeSelected.title) {
          this.selectedGroup.title = newNodeTitle;
        }
      }

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.isEdited = false;

      slVueTree.updateNode(nodeSelected.path, {
        title: newNodeTitle,
        data: nodeData
      });

      this.menuTags[this.getTagIndex(nodeData.id)].title = newNodeTitle;
      this.updateHierarchyAPI();
    },

    tagAdded() {
      this.$store.commit("setOverviewStats", true);
      this.updateHierarchyAPI();
    },

    toggleVisibility(node, event) {
      if (!this.disableDevice(node.data.type)) {
        const slVueTree = this.$refs.slVueTree;
        event.stopPropagation();

        let groupData = Object.assign({}, node.data);
        groupData.report_visible = !node.data.report_visible;

        slVueTree.updateNode(node.path, {
          data: groupData
        });

        this.updateHierarchyAPI();
      }
    },

    nodeDblClick(nodeSelected, event) {
      const slVueTree = this.$refs.slVueTree;
      event.stopPropagation();

      slVueTree.traverse((node, nodeModel, path) => {
        let nodeData = Object.assign({}, node.data);
        nodeData.isEdited = false;
        slVueTree.updateNode(node.path, { data: nodeData });
      });

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.isEdited = true;

      slVueTree.updateNode(nodeSelected.path, {
        data: nodeData
      });
    },

    formatOutput(selected) {
      let deviceList = [];

      if (!selected.isLeaf) {
        if (selected.children){
        for (let idx = 0; idx < selected.children.length; idx++) {
          if (selected.children[idx].isLeaf) {
            if (selected.children[idx].data.type == 2){
              if (selected.children[idx].data.report_visible){
                deviceList.push(selected.children[idx]);
              }
            }
          } else {
            deviceList = deviceList.concat(
              this.formatOutput(selected.children[idx])
            );
          }
        }
        }
      } else {
        if (selected.data.type == 2){
          if (selected.data.report_visible){
            deviceList.push(selected);
          }
        }
      }

      return deviceList;
    },

    nodeSelected(nodes, event) {
      if (this.showModal == false) {
        const slVueTree = this.$refs.slVueTree;
        event.stopPropagation();

        slVueTree.traverse((node, nodeModel, path) => {
          let nodeData = Object.assign({}, node.data);
          nodeData.isEdited = false;

          slVueTree.updateNode(node.path, {
            data: nodeData
          });
        });

        const selectedNode = nodes[0];
        if (!selectedNode.isLeaf || (selectedNode.isLeaf && !this.disableDevice(selectedNode.data.type) && selectedNode.data.report_visible)) {

          this.selectedGroup = {
            title: selectedNode.title,
            isLeaf: selectedNode.isLeaf,
            type: selectedNode.data.type,
            mac: selectedNode.data.mac
          };

          this.$emit("on-selected", this.formatOutput(selectedNode));
        }

        this.selectedGroup.dragTitle = selectedNode.title;
      }
    },

    nodeDropped(nodes, position, event) {
      this.updateHierarchyAPI();
    },

    nodeToggled(node, event) {
      this.updateHierarchyAPI();
    },

    nodeMouseEnter(nodeSelected, event) {
      const slVueTree = this.$refs.slVueTree;
      //event.stopPropagation();

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.showButton = true;

      slVueTree.updateNode(nodeSelected.path, {
        data: nodeData
      });
    },

    nodeMouseLeave(nodeSelected, event) {
      const slVueTree = this.$refs.slVueTree;
      event.stopPropagation();

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.showButton = false;

      slVueTree.updateNode(nodeSelected.path, {
        data: nodeData
      });
    },

    removeNode() {
      const $slVueTree = this.$refs.slVueTree;
      const path = $slVueTree.getSelected().map(node => node.path);
      const nodeTitle = $slVueTree.getSelected().map(node => node);
      const nodeChildren = $slVueTree.getSelected().map(node => node.children);

      if (nodeChildren[0].length == 0) {
        $slVueTree.remove(path);
        this.menuTags.splice(this.getTagIndex(nodeTitle[0].data.id), 1);
        this.updateHierarchyAPI();
      } else {
        this.$refs.snackbar.notify(this.$lang.messages.object_not_empty);
      }
    }
  }
};
</script>


<style lang="scss" scoped>
.md-button:not(.md-just-icon) .md-button-content i {
  height: 32px;
}

i {
  width: 33px;
  height: 33px;
  line-height: 33px;
  text-align: center;
}

.md-list {
  width: 320px;
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  border: 1px solid rgba(#000, 0.12);
}

.hierarchy-new-object {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.md-button {
  height: 40px;
}

.md-card-actions .md-layout-item {
  padding: 0;
}

.md-chips.md-field {
  padding: 0;
  margin: 0;
}

.items-inline {
  display: inline;
}

.md-button.md-just-icon {
  height: 35px;
}

@media only screen and (min-width: 500px) {
  .dropdown-menu {
    width: 400px;
  }
}

@media only screen and (min-width: 550px) {
  .dropdown-menu {
    width: 450px;
  }
}

@media only screen and (max-width: 450px) {
  .dropdown-menu {
    left: -55px;
  }
}

.dropdown-menu {
  min-width: 350px;
}

.status-icon {
  width: 10px;
  height: auto;
  /*   margin-right: 12px;  */
}
</style>


<style lang="scss">
@import "./src/assets/scss/md/_variables";

.modal-container {
  color: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(0, 0, 0, 0.87)
  );
}

.md-chips.md-field .md-input {
  max-width: 90px;
}

.sl-vue-tree.sl-vue-tree-root {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
  height: auto;
}

.sl-vue-tree {
  position: relative;
  cursor: default;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}

.sl-vue-tree.sl-vue-tree-root {
  background-color: #ffffff;
  color: #414d5c;
  border-radius: 3px;
}

.sl-vue-tree-root > .sl-vue-tree-nodes-list {
  overflow: hidden;
  position: relative;
  padding-bottom: 4px;
}

.sl-vue-tree-selected > .sl-vue-tree-node-item {
  background-color: #ffffff;
  color: #414d5c;
}
.sl-vue-tree-node-item:hover,
.sl-vue-tree-node-item.sl-vue-tree-cursor-hover {
  background-color: $green-300;
  color: #ffffff;
  cursor: pointer;
}

.sl-vue-tree-node-item {
  position: relative;
  display: flex;
  flex-direction: row;

  padding-left: 10px;
  padding-right: 10px;
  line-height: 35px;
  border: 1px solid transparent;
}

.sl-vue-tree-node-item.sl-vue-tree-cursor-inside {
  border: 1px solid rgba(255, 255, 255, 0.5);
}

@media only screen and (max-width: 500px) {
  .sl-vue-tree-gap {
    width: 10px;
    min-height: 1px;
  }
}

@media only screen and (min-width: 500px) {
  .sl-vue-tree-gap {
    width: 25px;
    min-height: 1px;
  }
}

.sl-vue-tree-toggle {
  display: inline-block;
  text-align: left;
  width: 20px;
}

.sl-vue-tree-sidebar {
  margin-left: auto;
}

.sl-vue-tree-cursor {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.5);
  height: 1px;
  width: 100%;
}

.sl-vue-tree-drag-info {
  position: absolute;
  background-color: $green-400;
  opacity: 0.85;
  margin-left: 20px;
  padding: 5px 10px;
}

.item-icon {
  display: inline-block;
  text-align: left;
  /* width: 20px;
  padding-right: 7px; */
}
</style>

